<template>
  <div class="orders">
    <HeaderBar
      title="Заявки"
      :showButtons="false"
      :ranges="ranges"
      @change-range="onChangeRange"
      @refresh="onRefresh"
      :statistic="statistic"
    />
    <RecentLeadsTable 
      @open-lead="openLead" 
      :requests="requests"  
      :page-size="20"
      :enable-load-more="true"
      :infinite="true"
    />
  </div>
</template>

<script>
import RecentLeadsTable from './RecentLeadsTable.vue';
import HeaderBar from './HeaderBar.vue'

import { mapGetters } from "vuex"

export default {
  name: 'AdminDashboard',
  components: { RecentLeadsTable, HeaderBar },
  props: ['requests'],
  data() {
    return {
      ranges: [
        {
          key: 'today',
          title: 'Сегодня'
        },
        {
          key: 'last_7_days',
          title: 'За 7 дней'
        },
        {
          key: 'current_week',
          title: 'За неделю'
        },
        {
          key: 'current_month',
          title: 'За месяц'
        },
        {
          key: 'last_90_days',
          title: 'За 90 дней'
        },
        {
          key: 'current_year',
          title: 'За год'
        },
        {
          key: 'all_time',
          title: 'За все время'
        }
      ],
    };
  },
  computed: {

  },
  methods: {
    onChangeRange () {

    },
    openLead () {

    },  
    getRangeTitle (key) {
      return this.ranges.find(item => item.key == key)?.title
    },
  },
  created () {
  },
  mounted() {
  
  }
};
</script>

<style scoped>
.orders {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  gap: 1rem;
}
</style>